import { attributionSchema } from "@medbillai/schemas/attribution";

import { authStorage } from "../storage/instances";

export const readPendingAttribution = async (): Promise<string | undefined> => {
  const raw = await authStorage.get("pendingAttribution");
  if (!raw) {
    return undefined;
  }
  try {
    return attributionSchema.safeParse(JSON.parse(raw)).success
      ? raw
      : undefined;
  } catch {
    return undefined;
  }
};
